import { Store } from "@ngxs/store";
import { firstValueFrom } from "rxjs";
import { assign, merge } from 'lodash';

import * as API from "@hiptraveler/data-access/api";
import * as Itinerary from '..';
import { getWindowRef, globalStateManagementStoreKey } from "@hiptraveler/common";
import { updateBasicInfoSharedFields } from "./common";

export async function getItineraryByPageTitle(pageTitle: string, ItineraryApi: API.ItineraryApiService, callback: (basicInfo: API.BasicInfoData) => void): Promise<Partial<Itinerary.ItineraryStateModel> | any> {

  const store = getWindowRef()?.[globalStateManagementStoreKey] as Store;
  const basicInfoSnapshot = store?.selectSnapshot(Itinerary.ItineraryState.basicInfo);
  const snapshotResponse = { basicInfo: basicInfoSnapshot } as any;
  
  try {

    const basicInfoResponse = basicInfoSnapshot
      ? snapshotResponse
      : await firstValueFrom(ItineraryApi.getItineraryByPageTitle(pageTitle));

    const itineraryId = basicInfoResponse?.basicInfo?.id || '';
    const basicInfoList = [];
    const itineraryTrips = [];
    let moreResults = true;
    let count = 1;

    callback(basicInfoResponse?.basicInfo);

    do {
      const itineraryTrip = await firstValueFrom(ItineraryApi.getItineraryTripByIdAndCount(itineraryId, count));

      if (count === 1) {
        const basicInfoState = assign({}, basicInfoSnapshot, basicInfoResponse?.basicInfo );
        if (itineraryTrip?.basicInfo?.autoSummary && !basicInfoState.autoSummary) {
          updateBasicInfoSharedFields(basicInfoState, itineraryTrip?.basicInfo);
        }
        callback(basicInfoState);
      }

      basicInfoList.push(itineraryTrip?.basicInfo || null);
      itineraryTrips.push(itineraryTrip?.itinerary?.actDateMap || null);
      moreResults = !!itineraryTrip?.itinerary?.moreResults;
      count++;
    } while (moreResults);

    basicInfoSnapshot || API.validateResponse(basicInfoResponse, { ignoreKey: 'basicInfo' });

    const basicInfoState = assign({}, basicInfoSnapshot, basicInfoResponse?.basicInfo );

    if (basicInfoList[0]?.autoSummary && !basicInfoState.autoSummary) {
      updateBasicInfoSharedFields(basicInfoState, basicInfoList[0]);
    }

    const baseResult: Partial<Itinerary.ItineraryStateModel> = {
      basicInfo: basicInfoState,
      actDateMap: merge({}, ...itineraryTrips),
      travelAgents: []
    };

    if (basicInfoResponse?.basicInfo?.hasItinerary) {
      if (!getWindowRef()?.location?.pathname?.includes('/compose/itinerary/')) {
        const taResponse = await firstValueFrom(ItineraryApi.getTravelAgentList(itineraryId)).catch(() => null);
        baseResult.travelAgents = taResponse?.travelAgents || [];
      }
      return baseResult;
    }

    return baseResult;
  } catch (value: any) {

    return basicInfoSnapshot
      ? { basicInfo: basicInfoSnapshot }
      : { error: value?.error };
  }
}
